<template>
  <div class="col-12">
    <div class="card mb-2 w-100">
      <div class="row">
        <div class="col-12 p-0">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3622.307745173819!2d-107.44054648455631!3d24.78491355438424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86bcd05dd90689c5%3A0x2c85d5b65a0de9b5!2sGrupo%20F%C3%A9lix!5e0!3m2!1ses-419!2smx!4v1597873791369!5m2!1ses-419!2smx"
                  frameborder="0"  allowfullscreen="" aria-hidden="false" tabindex="0" class="maps"></iframe>
        </div>
        <div class="col-12 row p-0">
          <div class="col-12">
            <p class="mb-16 mt-2 font-weight-bold  d-none d-md-block d-lg-block text-center">Sucursal</p>
            <h4 class="mb-32 text-center"><img src="@/assets/images/marcas/chevrolet.png" style="width: 60px;" class="" alt="Logo de chevrolet"> CHEVROLET | ZAPATA (MATRIZ)</h4>
          </div>
          <div class="col-12 col-lg-4">
            <p class="mb-16" style="font-size: 14px;">
              <strong>VENTAS:</strong>
              <br>
              Tel: 667 758 000
            </p>
            <p class="mb-16" style="font-size: 14px;">
              <strong>Dirección:</strong>
              <br>
              Blvd. Emiliano Zapata #1999 Vallado, Culiacán, Sinaloa.
            </p>
          </div>
          <div class="col-12 col-lg-4">
            <p class="mb-16" style="font-size: 14px;">
              <strong>SERVICIO:</strong>
              <br>
              Tel: 667 758 0006 <br>
              Whatsapp: 667 758 0006 <br>
              Correo: citaschevroletdelzapata@grupofelix.com.mx
            </p>
          </div>
          <div class="col-12 col-lg-4">
            <p class="mb-16" style="font-size: 14px;">
              <strong>REFACCIONES:</strong>
              <br>
              Tel: 667 758 0003
            </p>
            <p class="mb-16" style="font-size: 14px;">
              <strong>PostVenta:</strong>
              <br>
              • Refacciones <br>
              • Taller de Servicio Automotriz  <br>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactCard',
  props: {
    urlMap: String,
    officeName: String
  }
}
</script>

<style scoped>

</style>
